import { store } from "src/store";
import storage from "src/services/storage";
import router from "@/router/index";
import i18n from "@/services/i18n";

let is403AlertShown = false;

export async function fetchWithAuth(url, options = {}) {
  const response = await fetch(url, options);
  if (response.status === 401) {
    await store.dispatch("user/logout");
  }
  if ((response.status === 406 || response.status === 403) && !is403AlertShown) {
    is403AlertShown = true  
    router.push({ name: 'Home' })  
    router.app?.$toasted?.error(i18n.t("no_permission"), {
      position: "bottom-right",
      duration: 3000,
    });
    return;
  }
  return response;
}

export function authHeaders(extra = {}) {
  const token = storage.get("token");
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  return { ...headers, ...extra };
}
